const user        = require('../user');
const endpoint    = require('@readcube/endpoint');
const BasicModal  = require('../ctrl/basic_modal');

async function open() {
  const modal = BasicModal({
    title: `Inactive Subscription`,
    content: user.licence.used_trial
      ? `Your subscription has expired. Saving changes requires an active subscription, you can renew your subscription by clicking the button below.`
      : `Saving changes requires an active subscription, you can start a free trial by clicking the button below.`,
    buttons: [
      {
        text: user.licence.used_trial ? 'Renew Subscription' : 'Start Free Trial',
        primary: true,
        handler: () => {
          window.open(`${endpoint.web}/account`, '_blank');
          modal.close()
        }
      },
      {
        text: 'Cancel',
        handler: () => modal.close()
      }
    ]
  });

  return modal.open();
}

module.exports = { open };
